import { render, staticRenderFns } from "./ScrollBar.vue?vue&type=template&id=48b1d9f4&"
import script from "./ScrollBar.vue?vue&type=script&lang=js&"
export * from "./ScrollBar.vue?vue&type=script&lang=js&"
import style0 from "./ScrollBar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/easy_dev/extranet/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48b1d9f4')) {
      api.createRecord('48b1d9f4', component.options)
    } else {
      api.reload('48b1d9f4', component.options)
    }
    module.hot.accept("./ScrollBar.vue?vue&type=template&id=48b1d9f4&", function () {
      api.rerender('48b1d9f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ScrollBar.vue"
export default component.exports